export default "__VITE_ASSET__1Bp6pAYs__"